import { FC } from 'react'
import { NavLink } from 'react-router'
import { AssetColor, AssetSize, Icon, IconName, Tooltip, TooltipPlacement } from '@enbw/ui-react'
import styles from './styles.module.scss'

export type ModuleBarItem = {
  label: string
  path: string
  icon: IconName
  visible: boolean
}

export type ModuleBarProps = {
  items: ModuleBarItem[]
}

export const ModuleBar: FC<ModuleBarProps> = ({ items }) => {
  return (
    <nav className={styles.moduleBar}>
      {items.map(
        (item) =>
          item.visible && (
            <Tooltip key={item.path} placement={TooltipPlacement.Right}>
              <NavLink
                slot="trigger"
                to={item.path}
                className={({ isActive }) => `${styles.sidebarItem} ${isActive ? styles.sidebarItemActive : ''}`}
                aria-label={item.label}
              >
                {/*
                 * AssetColor.Default is intentionally used for both active and inactive states.
                 * When BrandPrimary is passed, the library generates a shadow-internal CSS rule
                 * (.asset.asset--brand-primary { --asset-color: var(--color-brand-primary) })
                 * that cannot be overridden from outside the shadow DOM, making hover colour
                 * changes impossible. With Default, --asset-color resolves to currentColor,
                 * so the icon inherits its colour from the parent NavLink's CSS color property,
                 * which we control via .sidebar-item-active and .sidebar-item:hover in the stylesheet.
                 */}
                <Icon name={item.icon} size={AssetSize.XSmall} color={AssetColor.Default} />
              </NavLink>
              <span slot="content">{item.label}</span>
            </Tooltip>
          )
      )}
    </nav>
  )
}
